module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-bs-white.cb3b8069.gif";